export default class OverviewController {
    constructor(elm, args) {

        var locLabel = elm.querySelector('[data-location-label]');
        var indLabel = elm.querySelector('[data-industry-label]');
        let container = elm.querySelector('[data-container]');
        var loadMoreButton = elm.querySelector('[data-load-more]');
        const noResultsEl = elm.querySelector('[data-no-results]');
        const resetLocationBtn = elm.querySelector('[data-reset-location]');

        const locationItemList = elm.querySelectorAll('[data-location-id]')
        locationItemList.forEach(x => x.onclick = (event) => {
            event.preventDefault();
            setFilter("location", x.innerHTML, x.dataset.locationId);
        });

        const industryItemList = elm.querySelectorAll('[data-industry-id]')
        industryItemList.forEach(x => x.onclick = (event) => {
            event.preventDefault();
            setFilter("industry", x.innerHTML, x.dataset.industryId);
        });

        loadMoreButton.onclick = (event) => {
            event.preventDefault();
            loadMore(parseInt(elm.dataset.page) + 1);
        }

        var dropdownHeadingButtons = elm.querySelectorAll('.dropdown');
        window.addEventListener('click', x => {
            var dropdownButton = x.target.closest('.dropdown')
            if (dropdownButton) {
                dropdownButton.classList.toggle('dropdown--active')
            } else {
                dropdownHeadingButtons.forEach(x => x.classList.remove('dropdown--active'))
            }
        })

        const urlParams = getUrlParams()
        const locationId = urlParams.locationId
        const industryId = urlParams.industryId

        elm.dataset.currentLocationId = (elm.dataset.currentLocationId ?? "");
        elm.dataset.currentIndustryId = (elm.dataset.currentIndustryId ?? "");

        let fetchAndLoadFlag = false;

        if (locationId != null) {
            elm.dataset.currentLocationId = locationId;
            fetchAndLoadFlag = true;
            const activeLabel = elm.querySelector('[data-location-id="' + locationId + '"]');
            if (activeLabel) locLabel.innerHTML = activeLabel.innerHTML;
        } else if (elm.dataset.currentLocationId) {
            // Silent default via data-attr
            const activeLabel = elm.querySelector('[data-location-id="' + elm.dataset.currentLocationId + '"]');
            if (activeLabel) locLabel.innerHTML = activeLabel.innerHTML;
        }

        if (industryId != null) {
            elm.dataset.currentIndustryId = industryId;

            fetchAndLoadFlag = true

            const industryLabel = elm.querySelector('[data-industry-label]');
            const activeLabel = elm.querySelector('[data-industry-id="' + industryId + '"]');

            if (activeLabel) {
                industryLabel.innerHTML = activeLabel.innerHTML
            }

        }

        // if (fetchAndLoadFlag) {
        //     FetchAndLoad(0)
        // }

        function toggleNoResults(show) {
            if (!noResultsEl) return;
            noResultsEl.classList.toggle('hidden', !show);

            if (resetLocationBtn) {
                const url = new URL(window.location.origin + window.location.pathname + window.location.search);
                url.searchParams.delete('locationId');
                resetLocationBtn.setAttribute('href', url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : ''));
            }
        }

        function FetchAndLoad(page) {
            elm.dataset.page = page;

            const q = new URLSearchParams();
            if (elm.dataset.currentLocationId) q.set('locationId', elm.dataset.currentLocationId);
            if (elm.dataset.currentIndustryId) q.set('industryId', elm.dataset.currentIndustryId);
            q.set('Page', page);
            q.set('culture', elm.dataset.culture);

            const url = `/umbraco/surface/${elm.dataset.fetchApi}/${elm.dataset.fetchMethod}?${q.toString()}`;

            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(json => {
                    if (page == 1) {
                        container.innerHTML = json.html.Result;
                    } else {
                        container.innerHTML += json.html.Result;
                    }
                    loadMoreButton.classList.toggle('d-none', parseInt(json.totalPages) <= parseInt(json.currentPage));
                    const tmp = document.createElement('div');
                    tmp.innerHTML = json.html.Result;
                    const count = tmp.querySelectorAll('.person-card').length;
                    toggleNoResults(count === 0 && page === 1);
                });
        }

        function setFilter(filterType, filterLabel, filterId) {
            const pageNr = 1

            if (filterType === "location") {
                locLabel.innerHTML = filterLabel;
                elm.dataset.currentLocationId = filterId;
                setUrlParams("locationId", filterId)
            }
            if (filterType === "industry") {
                indLabel.innerHTML = filterLabel;
                elm.dataset.currentIndustryId = filterId;
                setUrlParams("industryId", filterId);
                setUrlParams("locationId", elm.dataset.currentLocationId || "");
            }

            FetchAndLoad(pageNr)
        }

        if (resetLocationBtn) {
            resetLocationBtn.addEventListener('click', (e) => {
                e.preventDefault();
                elm.dataset.currentLocationId = "";
                const allItem = elm.querySelector('[data-location-id=""]');
                if (allItem) {
                    locLabel.innerHTML = allItem.innerHTML;
                }
                setUrlParams("locationId", "");
                FetchAndLoad(1);
            });
        }

        function loadMore(pageNr) {
            FetchAndLoad(pageNr);
            setUrlParams("p", pageNr);
        }

        function setUrlParams(key, value) {
            const currentUrlParams = getUrlParams();
            if (value === null || value === undefined || value === "") {
                delete currentUrlParams[key];
            } else {
                currentUrlParams[key] = value;
            }

            const url = new URL(window.location.origin + window.location.pathname);
            Object.keys(currentUrlParams).forEach(label => {
                url.searchParams.set(label, currentUrlParams[label]);
            });

            window.history.pushState({}, '', url.href);
        }

        function getUrlParams() {
            const url_string = window.location.href
            const url = new URL(url_string);

            const searchParams = {}

            const locationId = url.searchParams.get("locationId");
            if (locationId !== null && locationId !== "") {
                searchParams["locationId"] = locationId
            }

            const industryId = url.searchParams.get("industryId");
            if (industryId !== null && industryId !== "") {
                searchParams["industryId"] = industryId
            }

            return searchParams
        }
    }
}
